import { RnAttachmentPreview } from '@/components';

export default {
	name: 'rn-attachment-previews',
	components: {
		RnAttachmentPreview,
	},
	props: {
		attachments: {
			type: Array,
			default: () => [],
		},
	},
};
